<template>
      <BreadCrumb PageTitle=" Modifier une facture" />
    <EditFactureS />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditFactureS from "@/components/FactureS/EditFactureS.vue";
  
    export default defineComponent({
      name: "EditFactureSPage",
      components: {
        EditFactureS,
        BreadCrumb
      },
    });
  </script>